import { render } from "./PremiumModal.vue?vue&type=template&id=172561f0&scoped=true"
import script from "./PremiumModal.vue?vue&type=script&lang=js"
export * from "./PremiumModal.vue?vue&type=script&lang=js"

import "./PremiumModal.vue?vue&type=style&index=0&id=172561f0&scoped=true&lang=css"

import exportComponent from "../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172561f0"]])

export default __exports__